/* ============================================================
   ADEX theme behaviour. Vanilla JS, no dependencies.
   Cart uses Shopify's AJAX Cart API (/cart/*.js).
   ============================================================ */
(function () {
  "use strict";

  var money = function (cents) {
    if (window.Shopify && Shopify.formatMoney && window.adexMoneyFormat) {
      return Shopify.formatMoney(cents, window.adexMoneyFormat);
    }
    var n = (cents / 100).toFixed(2);
    var parts = n.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return "$" + parts.join(".");
  };

  /* ---------- Toasts ---------- */
  function toast(msg) {
    var wrap = document.querySelector(".adex-toast-wrap");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "adex-toast-wrap";
      document.body.appendChild(wrap);
    }
    var t = document.createElement("div");
    t.className = "adex-toast";
    t.textContent = msg;
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("show"); });
    setTimeout(function () {
      t.classList.remove("show");
      setTimeout(function () { t.remove(); }, 250);
    }, 2200);
  }
  window.adexToast = toast;

  /* ---------- Mobile / nav menu ---------- */
  function initMenu() {
    var btn = document.querySelector("[data-menu-toggle]");
    var nav = document.querySelector("[data-menu]");
    if (!btn || !nav || nav.hasAttribute("data-menu-ready")) return;
    btn.addEventListener("click", function () {
      var open = nav.classList.toggle("adex-hidden") === false;
      btn.setAttribute("aria-expanded", String(open));
      btn.querySelector(".icon-menu").style.display = open ? "none" : "block";
      btn.querySelector(".icon-close").style.display = open ? "block" : "none";
    });
    document.addEventListener("click", function (e) {
      if (!nav.classList.contains("adex-hidden") &&
          !nav.contains(e.target) && !btn.contains(e.target)) {
        nav.classList.add("adex-hidden");
        btn.setAttribute("aria-expanded", "false");
        btn.querySelector(".icon-menu").style.display = "block";
        btn.querySelector(".icon-close").style.display = "none";
      }
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll("[data-faq-item]").forEach(function (item) {
      var q = item.querySelector("[data-faq-q]");
      if (!q) return;
      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");
        var list = item.closest("[data-faq-list]");
        if (list) {
          list.querySelectorAll("[data-faq-item].is-open").forEach(function (other) {
            if (other !== item) {
              other.classList.remove("is-open");
              var oq = other.querySelector("[data-faq-q]");
              if (oq) oq.setAttribute("aria-expanded", "false");
            }
          });
        }
        item.classList.toggle("is-open", !isOpen);
        q.setAttribute("aria-expanded", String(!isOpen));
      });
    });
  }

  /* ---------- Rise-in on scroll ---------- */
  function initRiseIn() {
    var els = document.querySelectorAll(".rise-in");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("in-view"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Catalog filters ---------- */
  // Mirrors the original site's classification: each card carries
  // data-platform and data-category computed in Liquid. We just show/hide.
  function initCatalogFilters() {
    var root = document.querySelector("[data-catalog]");
    if (!root) return;
    var platformSel = root.querySelector("[data-filter-platform]");
    var categorySel = root.querySelector("[data-filter-category]");
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-product-card]"));
    var countEl = root.querySelector("[data-result-count]");
    var emptyEl = root.querySelector("[data-empty]");
    var gridEl = root.querySelector("[data-grid]");

    function apply() {
      var plat = platformSel ? platformSel.value : "All";
      var cat = categorySel ? categorySel.value : "All";
      var visible = 0;
      cards.forEach(function (card) {
        var mp = plat === "All" || card.getAttribute("data-platform") === plat;
        var mc = cat === "All" || card.getAttribute("data-category") === cat;
        var show = mp && mc;
        if (show) card.style.removeProperty("display"); else card.style.setProperty("display", "none", "important");
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + " " + (visible === 1 ? "Product" : "Products");
      if (emptyEl) emptyEl.style.display = visible === 0 ? "" : "none";
      if (gridEl) gridEl.style.display = visible === 0 ? "none" : "";
    }
    if (platformSel) platformSel.addEventListener("change", apply);
    if (categorySel) categorySel.addEventListener("change", apply);

    // Honour ?platform= deep link (matches original Link search param)
    var params = new URLSearchParams(window.location.search);
    var p = params.get("platform");
    if (p && platformSel) {
      var opt = Array.prototype.slice.call(platformSel.options).find(function (o) { return o.value === p; });
      if (opt) platformSel.value = p;
    }
    apply();
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return;
    var main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var url = thumb.getAttribute("data-img");
        var alt = thumb.getAttribute("data-alt") || "";
        if (main && url) { main.src = url; main.alt = alt; }
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ============================================================
     CART (Shopify AJAX API)
     ============================================================ */
  var Cart = {
    open: function () {
      var d = document.querySelector("[data-cart-drawer]");
      var o = document.querySelector("[data-cart-overlay]");
      if (d) d.classList.add("is-open");
      if (o) o.classList.add("is-open");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      var d = document.querySelector("[data-cart-drawer]");
      var o = document.querySelector("[data-cart-overlay]");
      if (d) d.classList.remove("is-open");
      if (o) o.classList.remove("is-open");
      document.body.style.overflow = "";
    },
    getJSON: function () {
      return fetch(window.Shopify.routes.root + "cart.js", {
        headers: { "Content-Type": "application/json" }
      }).then(function (r) { return r.json(); });
    },
    add: function (variantId, qty) {
      return fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    change: function (key, qty) {
      return fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    },
    render: function (cart) {
      var body = document.querySelector("[data-cart-body]");
      var foot = document.querySelector("[data-cart-foot]");
      if (!body) return;

      // header / badge counts
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute("hidden");
        else el.setAttribute("hidden", "");
      });
      var titleCount = document.querySelector("[data-cart-title-count]");
      if (titleCount) titleCount.textContent = "(" + cart.item_count + ")";

      if (!cart.items || cart.items.length === 0) {
        body.innerHTML =
          '<div class="adex-drawer__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="40" height="40"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>' +
          '<p class="eyebrow">Your cart is empty</p>' +
          '<button type="button" class="btn-ghost" data-cart-continue>Continue Shopping</button>' +
          "</div>";
        if (foot) foot.style.display = "none";
        return;
      }
      if (foot) foot.style.display = "";

      var html = "";
      cart.items.forEach(function (item) {
        var img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, "_160x$1") : "";
        var variant = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : "";
        html +=
          '<div class="adex-line" data-line-key="' + item.key + '">' +
            '<div class="adex-line__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + "</div>" +
            '<div class="adex-line__main">' +
              '<a href="' + item.url + '" class="adex-line__title">' + item.product_title + "</a>" +
              (variant ? '<div class="adex-line__variant">' + variant + "</div>" : "") +
              '<div class="adex-line__row">' +
                '<div class="adex-qty">' +
                  '<button type="button" data-qty-dec aria-label="Decrease">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                  "</button>" +
                  "<span>" + item.quantity + "</span>" +
                  '<button type="button" data-qty-inc aria-label="Increase">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
                  "</button>" +
                "</div>" +
                '<span class="adex-line__price">' + money(item.final_line_price) + "</span>" +
              "</div>" +
              '<button type="button" class="adex-line__remove" data-line-remove>Remove</button>' +
            "</div>" +
          "</div>";
      });
      body.innerHTML = html;

      var sub = document.querySelector("[data-cart-subtotal]");
      if (sub) sub.textContent = money(cart.total_price);

      Cart.bindLines();
    },
    bindLines: function () {
      document.querySelectorAll("[data-line-key]").forEach(function (line) {
        var key = line.getAttribute("data-line-key");
        var qtyEl = line.querySelector(".adex-qty span");
        var current = parseInt(qtyEl ? qtyEl.textContent : "1", 10);
        var dec = line.querySelector("[data-qty-dec]");
        var inc = line.querySelector("[data-qty-inc]");
        var rm = line.querySelector("[data-line-remove]");
        if (dec) dec.addEventListener("click", function () { Cart.update(key, Math.max(0, current - 1)); });
        if (inc) inc.addEventListener("click", function () { Cart.update(key, current + 1); });
        if (rm) rm.addEventListener("click", function () { Cart.update(key, 0); });
      });
    },
    update: function (key, qty) {
      Cart.change(key, qty).then(function (cart) { Cart.render(cart); });
    },
    refresh: function () {
      Cart.getJSON().then(function (cart) { Cart.render(cart); });
    }
  };
  window.adexCart = Cart;

  function initCart() {
    if (!window.Shopify || !window.Shopify.routes) {
      window.Shopify = window.Shopify || {};
      window.Shopify.routes = window.Shopify.routes || { root: "/" };
    }

    document.addEventListener("click", function (e) {
      var toggle = e.target.closest("[data-cart-toggle]");
      if (toggle) { e.preventDefault(); Cart.refresh(); Cart.open(); return; }
      if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-overlay]") || e.target.closest("[data-cart-continue]")) {
        Cart.close(); return;
      }
    });

    // Add-to-cart buttons (catalog cards + product page)
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-add-to-cart]");
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<svg class="adex-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';
      Cart.add(variantId, 1)
        .then(function () { return Cart.getJSON(); })
        .then(function (cart) {
          Cart.render(cart);
          toast("Added to cart");
          Cart.open();
        })
        .catch(function (err) {
          toast((err && err.description) ? err.description : "Could not add to cart");
        })
        .finally(function () {
          btn.disabled = false;
          btn.innerHTML = original;
        });
    });

    Cart.refresh();
  }

  var protectionId = 44168752431167;
  var protectionQueue = Promise.resolve();
  var lastCart = null;
  var protectionBusy = false;
  var rawGetCart = Cart.getJSON;
  var rawChangeCart = Cart.change;
  var rawRenderCart = Cart.render;
  function isProtection(item) { return Number(item.variant_id || item.id) === protectionId; }
  function coveredQuantity(cart) {
    return cart.items.reduce(function (n, item) { return n + (!isProtection(item) && item.requires_shipping !== false ? item.quantity : 0); }, 0);
  }
  function merchandiseTotal(cart) {
    var lines = cart.items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    return Math.max(0, lines - (cart.cart_level_discount_applications || []).reduce(function (sum, discount) { return sum + discount.total_allocated_amount; }, 0));
  }
  function protectionRequest(endpoint, body) {
    return fetch(window.Shopify.routes.root + endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || 'Could not update package protection. Please try again.');
        return data;
      });
    });
  }
  function syncProtection(choice) {
    var task = protectionQueue.catch(function () {}).then(async function () {
      var cart = await rawGetCart();
      if (choice !== undefined) {
        cart = await protectionRequest('cart/update.js', { attributes: { adex_package_protection: choice ? 'yes' : 'no' } });
      }
      var quantity = cart.attributes && cart.attributes.adex_package_protection === 'no' ? 0 : coveredQuantity(cart);
      var lines = cart.items.filter(isProtection);
      for (var i = 1; i < lines.length; i++) await rawChangeCart(lines[i].key, 0);
      if (lines.length && lines[0].quantity !== quantity) cart = await rawChangeCart(lines[0].key, quantity);
      else if (!lines.length && quantity) {
        await protectionRequest('cart/add.js', { items: [{ id: protectionId, quantity: quantity }] });
        cart = await rawGetCart();
      } else if (lines.length > 1) cart = await rawGetCart();
      lastCart = cart;
      return cart;
    });
    protectionQueue = task;
    return task;
  }
  Cart.getJSON = function () { return syncProtection(); };
  Cart.change = function (key, qty) {
    var line = lastCart && lastCart.items.find(function (item) { return item.key === key; });
    if (line && isProtection(line)) return syncProtection(false);
    return rawChangeCart(key, qty).then(function () { return syncProtection(); });
  };
  function protectionPanel(cart) {
    var count = coveredQuantity(cart);
    var selected = cart.items.some(isProtection);
    var fee = cart.items.filter(isProtection).reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    document.querySelectorAll('form button[name="checkout"]').forEach(function (button) {
      var form = button.form;
      if (!form) return;
      var panel = form.querySelector('[data-protection-panel]');
      if (!panel) {
        panel = document.createElement('div');
        panel.setAttribute('data-protection-panel', '');
        panel.className = 'adex-protection';
        panel.innerHTML = '<div class="adex-protection__row"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 3 3 7v5c0 5 9 9 9 9s9-4 9-9V7z"/><path d="m8 12 3 3 5-6"/></svg><div><strong>ADEX Package Protection</strong><span>Lost shipments &amp; shipping damage</span></div><b data-protection-price></b></div><p data-protection-detail></p><details><summary>Coverage details</summary><p>Optional protection for lost shipments and shipping damage. Theft after delivery is not covered. Contact info@adexcarbon.com with your order number for assistance.</p></details><button type="button" data-protection-toggle></button><p role="status" data-protection-status></p>';
        button.parentNode.insertBefore(panel, button);
        panel.querySelector('[data-protection-toggle]').addEventListener('click', function () {
          setProtection(!lastCart.items.some(isProtection), false);
        });
        var without = document.createElement('button');
        without.type = 'button';
        without.className = 'adex-protection__without';
        without.setAttribute('data-checkout-without-protection', '');
        without.textContent = 'Checkout without package protection';
        button.insertAdjacentElement('afterend', without);
        without.addEventListener('click', function () { setProtection(false, true); });
      }
      panel.hidden = !count;
      panel.querySelector('[data-protection-price]').textContent = selected ? money(fee) : money(count * 2499);
      panel.querySelector('[data-protection-detail]').textContent = '$24.99 per item × ' + count + (selected ? ' · Included in total' : ' · Not added');
      panel.querySelector('[data-protection-toggle]').textContent = selected ? 'Remove protection' : 'Add protection';
      button.textContent = (selected ? 'Protected checkout | ' : 'Checkout | ') + money(merchandiseTotal(cart));
      button.disabled = !count || protectionBusy;
      var without = form.querySelector('[data-checkout-without-protection]');
      if (without) { without.hidden = !selected || !count; without.disabled = protectionBusy; }
    });
  }
  Cart.render = function (cart) {
    lastCart = cart;
    var visible = Object.assign({}, cart, { items: cart.items.filter(function (item) { return !isProtection(item); }) });
    visible.item_count = visible.items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    rawRenderCart(visible);
    protectionPanel(cart);
    document.querySelectorAll('.adex-sku-row').forEach(function (row) {
      var link = row.querySelector('a[href*="/products/adex-package-protection"]');
      if (link) row.hidden = true;
      else {
        var productLink = row.querySelector('a[href*="/products/"]');
        var item = productLink && cart.items.find(function (entry) { return productLink.getAttribute('href') === entry.url; });
        if (item) {
          var quantity = row.querySelector('.adex-qty span');
          var price = row.querySelector('.adex-sku-row__price');
          var increase = row.querySelector('a[aria-label="Increase"]');
          if (quantity) quantity.textContent = item.quantity;
          if (price) price.textContent = money(item.final_line_price);
          if (increase) increase.href = window.Shopify.routes.root + 'cart/change?id=' + encodeURIComponent(item.key) + '&quantity=' + (item.quantity + 1);
        } else row.hidden = true;
      }
    });
    document.querySelectorAll('.adex-drawer__subtotal-val').forEach(function (el) { el.textContent = money(merchandiseTotal(cart)); });
  };
  async function setProtection(choice, checkout) {
    if (protectionBusy) return;
    protectionBusy = true;
    if (lastCart) protectionPanel(lastCart);
    document.querySelectorAll('[data-protection-status]').forEach(function (el) { el.textContent = 'Updating…'; });
    try {
      var cart = await syncProtection(choice);
      Cart.render(cart);
      if (checkout && coveredQuantity(cart)) window.location.assign(window.Shopify.routes.root + 'checkout');
    } catch (error) {
      toast(error.message || 'Could not update your cart. Please try again.');
    } finally {
      protectionBusy = false;
      if (lastCart) protectionPanel(lastCart);
      document.querySelectorAll('[data-protection-status]').forEach(function (el) { el.textContent = ''; });
    }
  }
  document.addEventListener('submit', function (event) {
    if (!event.target.querySelector('[data-protection-panel]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    setProtection(undefined, true);
  }, true);
  var protectionStyle = document.createElement('style');
  protectionStyle.textContent = '.adex-protection{width:100%;flex-basis:100%;background:#f6f6f3;border:1px solid #ded8c8;border-radius:14px;padding:16px;margin:12px 0;color:#161616;text-align:left}.adex-protection__row{display:flex;gap:10px;align-items:center}.adex-protection__row svg{color:#9b824c;flex-shrink:0}.adex-protection__row div{flex:1}.adex-protection strong{display:block;font-size:13px}.adex-protection span,.adex-protection p,.adex-protection summary{font-size:12px;line-height:1.5}.adex-protection span{display:block;color:#555}.adex-protection p{margin:8px 0}.adex-protection b{font-size:14px;white-space:nowrap}.adex-protection summary{cursor:pointer}.adex-protection [data-protection-toggle]{background:none;border:0;padding:8px 0 0;text-decoration:underline;color:#246143;font-size:12px;cursor:pointer}.adex-protection__without{display:block;width:100%;flex-basis:100%;background:none;border:0;text-decoration:underline;color:#333;padding:12px;font-size:13px;cursor:pointer}.adex-protection__without[hidden],.adex-protection[hidden],.adex-sku-row[hidden]{display:none!important}.adex-protection [data-protection-status]:empty{display:none}.adex-checkout-btn{white-space:normal}.adex-protection button:focus-visible,.adex-protection__without:focus-visible{outline:2px solid #246143;outline-offset:3px}';
  document.head.appendChild(protectionStyle);

  /* ---------- Boot ---------- */
  function boot() {
    initMenu();
    initFaq();
    initRiseIn();
    initCatalogFilters();
    initGallery();
    initCart();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();


